webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(56),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ZipcodeChart__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ZipcodeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ZipcodeChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blog_BassFishing__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__blog_BassFishing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__blog_BassFishing__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: __dirname,
  routes: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Intro___default.a
  }, {
    path: '/lunar-fishing-calendar/:zipcode',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ZipcodeChart___default.a
  }, {
    path: '/lunar-fishing-calendar',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ZipcodeChart___default.a
  }, {
    path: '/largemouth-bass-fishing',
    component: __WEBPACK_IMPORTED_MODULE_4__blog_BassFishing___default.a
  }]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(53),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_charts__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_adsense__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_circle_o_notch__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_charts___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('adsense', __WEBPACK_IMPORTED_MODULE_4_vue_adsense__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    adClient: {
      type: String,
      required: true
    },
    adSlot: {
      type: String,
      required: true
    },
    adFormat: {
      type: String,
      required: false,
      default: 'auto'
    },
    adStyle: {
      type: String,
      required: false,
      default: 'display: block'
    }
  },
  mounted: function mounted() {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: {
    scroll: function scroll() {
      window.scrollTo(0, 0);
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BassFishing',
  created: function created() {
    window.document.title = 'Largemouth Bass Fishing';
    var desc = document.getElementById('description');
    desc.content = 'The basics of Largemouth Bass FIshing';
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Intro',
  data: function data() {
    return {
      zipcode: ''
    };
  },
  methods: {
    getZipCodeChart: function getZipCodeChart() {
      this.$router.push('/lunar-fishing-calendar/' + this.zipcode);
    }
  },
  created: function created() {
    window.document.title = 'Lunar Fishing Calendar | Fishing calendar for the best fishing days';
    if (this.$route.query.zipCode && this.$route.query.zipCode.length === 5) {
      this.$router.push('/lunar-fishing-calendar/' + this.$route.query.zipCode);
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ZipcodeChart',
  data: function data() {
    var _this = this;

    return {
      zipcode: '',
      loading: true,
      reloading: true,
      showChartSections: false,
      city: '',
      state: '',
      chart: {},
      year: '',
      month: '',
      monthName: '',
      monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      selectedDay: '',
      selectedRating: '',
      selectedSunrise: '',
      selectedSunset: '',
      majorFeedingTimeOne: '',
      majorFeedingTimeTwo: '',
      minorFeedingTimeOne: '',
      minorFeedingTimeTwo: '',
      moonIllumination: '',
      chartEvents: {
        'select': function select() {
          var chart = _this.$refs.googleChart.chart;
          var selection = chart.getSelection();
          _this.setDaySection(selection[0].row, _this.chart);
        },
        'ready': function ready() {
          _this.loading = false;
          _this.selectToday(_this.chart);
        }
      },
      columns: [{ type: 'date', label: 'Day' }, { type: 'number', label: 'Rating' }],
      rows: [],
      options: {},
      invalidZipcode: false
    };
  },

  methods: {
    initialize: function initialize() {
      var _this2 = this;

      this.loading = true;
      this.reloading = true;
      this.zipcode = this.$route.params.zipcode;
      var d = new Date();
      this.year = d.getFullYear();
      this.monthName = this.monthNames[d.getMonth()];
      if (this.validate(this.zipcode)) {
        this.showChartSections = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.getBaseUrl() + '/chartByZipCode?zip=' + this.zipcode).then(function (response) {
          _this2.chart = response.data;
          _this2.city = _this2.chart.zipCodeHit.city;
          _this2.state = _this2.chart.zipCodeHit.state;
          _this2.monthName = _this2.chart.moonTimes[0].strMonth;
          _this2.year = _this2.chart.moonTimes[0].year;
          _this2.$nextTick(function () {
            _this2.options = _this2.getOptions(_this2.chart);
            _this2.rows = _this2.getRows(_this2.chart);
            _this2.reloading = false;
          });
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    getZipCodeChart: function getZipCodeChart() {
      this.$router.push('/lunar-fishing-calendar/' + this.zipcode);
    },
    validate: function validate(zip) {
      if (!zip) {
        return false;
      }
      if (zip.length !== 5) {
        this.invalidZipcode = true;
        return false;
      }
      this.invalidZipcode = false;
      return true;
    },
    getBaseUrl: function getBaseUrl() {
      var baseUrl = '';
      if (false) {
        baseUrl = 'http://localhost:8080';
      }
      return baseUrl;
    },
    getRows: function getRows(chartData) {
      var rows = [];
      var length = chartData.moonTimes.length;
      for (var i = 0; i < length; i++) {
        var mt = chartData.moonTimes[i];
        rows.push([new Date(mt.year, mt.month - 1, mt.day), mt.rating]);
      }
      return rows;
    },
    getOptions: function getOptions(chartData) {
      this.monthName = chartData.moonTimes[0].strMonth;
      this.month = chartData.moonTimes[0].month;
      this.year = chartData.moonTimes[0].year;

      return {
        curveType: 'function',
        legend: { position: 'none' },
        vAxis: {
          maxValue: 45,
          title: 'Fish Activity Ratings',
          textPosition: 'in',
          gridlines: { color: 'transparent' }
        },
        hAxis: {
          allowContainerBoundaryTextCufoff: true,
          showTextEvery: 1,
          maxTextLines: 1,
          maxAlternation: 1,
          minTextSpacing: 0,
          viewWindowMode: 'maximized',
          ticks: [{ v: new Date(this.year, this.month - 1, 1), f: this.monthName + ' 1' }, { v: new Date(this.year, this.month - 1, 7), f: '7' }, { v: new Date(this.year, this.month - 1, 14), f: '14' }, { v: new Date(this.year, this.month - 1, 21), f: '21' }, { v: new Date(this.year, this.month - 1, 28), f: '28' }]
        },
        chartArea: {
          left: 18,
          width: '100%',
          height: '80%'
        },
        axisTitlesPosition: 'in'
      };
    },
    selectToday: function selectToday(chartData) {
      var chart = this.$refs.googleChart.chart;
      var today = new Date().getDate() - 1;
      if (new Date().getMonth() === chartData.moonTimes[0].month - 1) {
        chart.setSelection([{ row: today, column: 1 }]);
        this.setDaySection(today, chartData);
      } else {
        chart.setSelection([{ row: 0, column: 1 }]);
        this.setDaySection(0, chartData);
      }
    },
    setDaySection: function setDaySection(selectedDay, chartData) {
      var mt = chartData.moonTimes[selectedDay];
      this.selectedDay = this.monthName + ' ' + (selectedDay + 1) + ', ' + this.year;
      this.selectedRating = mt.rating;
      this.selectedSunrise = mt.strSunrise;
      this.selectedSunset = mt.strSunset;
      this.majorFeedingTimeOne = mt.strMoonDownPeak;
      this.majorFeedingTimeTwo = mt.strMoonUpPeak;
      this.minorFeedingTimeOne = mt.strMoonrise;
      this.minorFeedingTimeTwo = mt.strMoonset;
      this.moonIllumination = mt.moonIllumination + '%';
      this.moonImage = '';
    },
    goToNextMonth: function goToNextMonth(chartData) {
      var _this3 = this;

      this.reloading = true;
      this.loading = true;
      var month = this.month === 12 ? 1 : this.month + 1;
      var year = this.month === 12 ? this.year + 1 : this.year;
      var lat = chartData.zipCodeHit.latitude;
      var long = chartData.zipCodeHit.longitude;
      var state = this.state;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.getBaseUrl() + '/chartByMonthYear?month=' + month + '&year=' + year + '&latitude=' + lat + '&longitude=' + long + '&state=' + state).then(function (response) {
        _this3.chart = response.data;
        _this3.options = _this3.getOptions(_this3.chart);
        _this3.rows = _this3.getRows(_this3.chart);
        _this3.reloading = false;
      }).catch(function (error) {
        console.log(error);
      });
    },
    goToNextYear: function goToNextYear(chartData) {
      var _this4 = this;

      this.reloading = true;
      this.loading = true;
      var year = this.year + 1;
      var lat = chartData.zipCodeHit.latitude;
      var long = chartData.zipCodeHit.longitude;
      var state = this.state;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.getBaseUrl() + '/chartByMonthYear?month=' + 1 + '&year=' + year + '&latitude=' + lat + '&longitude=' + long + '&state=' + state).then(function (response) {
        _this4.chart = response.data;
        _this4.month = _this4.chart.moonTimes[1].strMonth;
        _this4.year = _this4.chart.moonTimes[1].strMonth;
        _this4.options = _this4.getOptions(_this4.chart);
        _this4.rows = _this4.getRows(_this4.chart);
        _this4.reloading = false;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    window.document.title = 'Lunar Fishing Calendar - Free Solunar Charts';
    var desc = document.getElementById('description');
    desc.content = 'Get a free LUNAR FISHING CALENDAR based on your Zip Code and be a more successful fisherman';
    this.initialize();
  },
  watch: {
    $route: function $route() {
      this.initialize();
    }
  }
});

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(52),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ins', {
    staticClass: "adsbygoogle",
    style: (_vm.adStyle),
    attrs: {
      "data-ad-client": _vm.adClient,
      "data-ad-slot": _vm.adSlot,
      "data-ad-format": _vm.adFormat
    }
  })
},staticRenderFns: []}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("FISH FEEDING CHART")])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-leave": _vm.scroll
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "act row top-buffer"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('adsense', {
    staticClass: "adsbygoogle",
    attrs: {
      "ad-client": "ca-pub-1632304178786452",
      "ad-slot": "8387166617",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-1 col-xs-12"
  }, [_c('h2', [_vm._v("Fishing for Largemouth Bass")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    staticStyle: {
      "padding-top": "20px"
    },
    attrs: {
      "src": "/static/img/largemouth-bass-fishing.jpg",
      "title": "fishing for largemouth bass"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "30px"
    }
  }, [_vm._v("\n          For many people, the largemouth bass holds a special place in their hearts. It was the first fish they caught and helped\n          spark a life long passion for fishing and enjoying the outdoors with family and friends. The largemouth bass,\n          aptly named for its huge mouth, is extremely prolific and prospers in every continental U.S. state. It can be\n          found in rivers, lakes and nearly every golf course, neighborhood and farm pond in the nation. With its very\n          large mouth, the largemouth has evolved to be an aggressive predator, feeding on everything from frogs, bugs,\n          and smaller fish to mice and even baby ducks.\n        ")]), _vm._v(" "), _c('h3', [_vm._v("Structure and Vegetation")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9 col-xs-12"
  }, [_c('p', [_vm._v("Largemouth love to hang out near structure. This can be a fallen tree, a dock, or a bridge. In one of my favorite\n              ponds, there is almost always a bass hanging out in the same drain pipe, day after day. Structure includes\n              any feature in a body of water that attracts smaller fish and provides an ambush opportunity for a bass.\n              In addition to structure, bass also love vegetation such as lily pads, where they can attack frogs from below,\n              and overhanging trees, where they can hide in the shade. When fishing near structure fisherman can take advantage\n              of weedless hooks rigged Texas style to prevent getting snagged.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-12"
  }, [_c('div', {
    staticClass: "well"
  }, [_c('strong', [_vm._v("Did you know")]), _vm._v(" that the current world record largemouth is 22 lbs 4 oz and caught in Japan!")])])]), _vm._v(" "), _c('h3', [_vm._v("Spawning")]), _vm._v(" "), _c('p', [_vm._v("In the Spring, when water temps warm up above 60 degrees, bass start spawning. During spawning periods, male largemouth\n          create a bed with their tails, which you can often see as a clear, circular spot on the side of a pond. Once\n          the bed is made and the male bass finds a female, the two swim around the bed and fertilize eggs. Then the male\n          bass guards the eggs and fry (baby fish) after they hatch for up to two weeks. During this time, the male bass\n          does not feed much, but can be still be caught from a protection bite. Sometimes dragging a bait near a bed multiple\n          times can produce a protective reaction bite from the male bass. Once the baby bass get big enough to fend for\n          themselves, the male and female bass will return to their normal feeding habits. ")]), _vm._v(" "), _c('h3', [_vm._v("Tackle Box Basics")]), _vm._v(" "), _c('p', [_vm._v("\n          By far, the most popular and successful bass bait is the soft plastic jig. These come in a myriad number of styles, colors\n          and sizes and are most often rigged with a worm hook and a small bullet weight. Although, they are a bit pricey,\n          the\n          "), _c('a', {
    attrs: {
      "href": "http://amzn.to/2zJwg1J",
      "target": "_blank",
      "title": "Gary Yamamato Senko from Amazon.com"
    }
  }, [_vm._v("Gary Yamamato Senko")]), _vm._v(" is very deadly on bass and because they are somewhat heavy, you can cast them quite far.\n          Any of these can be rigged weedless by poking the tip of a worm hook into the plastic and stopping it before\n          it protrudes out too far. Try different retrieve speeds and weights (or no weight at all) until you figure out\n          what the bass are hitting on a given day.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          The spinner bait is another popular lure and is pretty weedless on its own. A spinnerbait contains one or more spinner blades\n          and a separate hook. The spinner blades whirl around when retrieving the bait and look like a wounded bait fish\n          to a bass.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          If you want to mix it up further, you can also try crank baits and topwater lures. Crank baits have a large bill in the front\n          of the lure, which causes the lure dive and shimmy when reeled in. These usually have one or two treble hooks,\n          making them very non-weedless which means that they are better in open water and away from structure and snags.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Topwater fishing can be some of the most exciting fishing you can ever do. Seeing and hearing a bass come out of the water\n          and explode on a topwater bait is awesome. Topwater frogs can be very effective around structure and lily pads\n          because they are mostly weedless, but there are also other classic topwater baits such as the Jitter Bug and\n          the Zara Spook. Give them a try in the early morning and late evening for the most success.\n        ")]), _vm._v(" "), _c('h3', [_vm._v("Conclusion")]), _vm._v(" "), _c('p', [_vm._v("Largemouth bass fishing is extremely accessible and easy to get started in. You don't need a fancy bass boat or\n          a ton of fishing gear to give it a try. Just walk down to your neighborhood pond with a Texas rigged jig and\n          start casting. Try different color and weight combinations. Try different retrieve speeds. Be patient and most\n          importantly, have fun!")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col top-buffer"
  }, [_c('h4', [_vm._v("Also interested in Hunting? ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('a', {
    attrs: {
      "href": "https://www.deerfeedingchart.com"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Best Hunting Days")])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 top-buffer"
  }, [_c('adsense', {
    staticClass: "adsbygoogle",
    attrs: {
      "ad-client": "ca-pub-1632304178786452",
      "ad-slot": "8387166617",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "heading"
  }, [_vm._v("LUNAR FISHING CALENDAR")]), _vm._v(" "), _c('p', [_vm._v("Enter your zipcode below for the best times to fish according to our solunar forecast. The charts will show major\n          and minor feeding times, plus sunrise and sunset data so that you can plan your fishing trip accordingly.")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "number",
      "title": "Enter Zipcode for Lunar Fishing Calendar",
      "id": "zipCode",
      "placeholder": "Enter Zip Code",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getZipCodeChart($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon sbt",
    attrs: {
      "title": "Get Lunar Fishing Calendar",
      "id": "getChart"
    },
    on: {
      "click": _vm.getZipCodeChart
    }
  }, [_vm._v("GET CHART")])]), _vm._v(" "), (_vm.invalidZipcode) ? _c('div', [_c('div', {
    staticClass: "alert alert-danger top-buffer",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Please enter a valid 5 digit Zipcode and resubmit")])]) : _vm._e()], 1), _vm._v(" "), (_vm.showChartSections) ? _c('div', {
    staticClass: "col-sm-12 top-buffer"
  }, [_c('div', {
    staticClass: "panel panel-default",
    class: {
      opaque: _vm.loading
    },
    staticStyle: {
      "height": "316px"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', [_c('b', [_vm._v("Predictions for " + _vm._s(_vm.city) + ", " + _vm._s(_vm.state))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.monthName))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "id": "nextMonthButton"
    },
    on: {
      "click": function($event) {
        _vm.goToNextMonth(_vm.chart)
      }
    }
  }, [_vm._v("Next Month\n                "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "disabled": "disabled",
      "id": "currentYearButton"
    }
  }, [_vm._v(_vm._s(_vm.year))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "id": "nextYearButton"
    },
    on: {
      "click": function($event) {
        _vm.goToNextYear(_vm.chart)
      }
    }
  }, [_vm._v(_vm._s(_vm.year + 1))])]), _vm._v(" "), _c('div', {
    staticClass: "img-responsive",
    attrs: {
      "id": "curve_chart"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "text-center top-buffer",
    attrs: {
      "id": "chartSection"
    }
  }, [_c('icon', {
    attrs: {
      "name": "circle-o-notch",
      "scale": "4",
      "spin": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.reloading) ? _c('vue-chart', {
    ref: "googleChart",
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "options": _vm.options,
      "chart-events": _vm.chartEvents
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.showChartSections) ? _c('div', {
    staticClass: "col-sm-12",
    attrs: {
      "id": "dayChartSection"
    }
  }, [_c('div', {
    staticClass: "panel panel-default",
    class: {
      opaque: _vm.loading
    },
    attrs: {
      "id": "dayChartSection"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h5', [_c('b', [_vm._v(_vm._s(_vm.selectedDay))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: " panel panel-primary "
  }, [_c('div', {
    staticClass: "panel-heading text-center"
  }, [_vm._v("Fish Activity Rating\n                    "), _c('h2', [_vm._v(_vm._s(_vm.selectedRating))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: " panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Sunrise")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedSunrise))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sunset")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedSunset))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Major Feeding Times")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.majorFeedingTimeOne) + "\n                            "), _c('br'), _vm._v(_vm._s(_vm.majorFeedingTimeTwo))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Minor Feeding Times")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.minorFeedingTimeOne) + "\n                            "), _c('br'), _vm._v(_vm._s(_vm.minorFeedingTimeTwo))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: " panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body text-center"
  }, [_c('img', {
    staticClass: "center-block img-responsive",
    attrs: {
      "src": __webpack_require__(47)
    }
  }), _vm._v("Moon Illumination\n                    "), _c('h4', [_vm._v(_vm._s(_vm.moonIllumination))])])])])])])])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zipcode),
      expression: "zipcode"
    }],
    staticClass: "form-control",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "number",
      "title": "Enter Zipcode for Lunar Fishing Calendar",
      "id": "zipCode",
      "placeholder": "Enter Zip Code",
      "aria-describedby": "basic-addon2"
    },
    domProps: {
      "value": (_vm.zipcode)
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getZipCodeChart($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zipcode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon sbt",
    attrs: {
      "title": "Get Lunar Fishing Calendar",
      "id": "getChart"
    },
    on: {
      "click": _vm.getZipCodeChart
    }
  }, [_vm._v("GET CHART")])]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "drr"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "act row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('adsense', {
    staticClass: "adsbygoogle",
    attrs: {
      "ad-client": "ca-pub-1632304178786452",
      "ad-slot": "8387166617",
      "ad-style": "display: block",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row hunt"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("SOLUNAR DATA")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12"
  }, [_c('p', [_vm._v("\n            Experienced fishermen around the country have long known that fish and other wildlife respond strongly to lunar phases. If\n            you have witnessed a hot bite one day and a slow bite a few days later, then you know exactly what we are talking\n            about. Fishing can be much better during certain times of the month.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Our lunar fishing calendar predicts a general fishing forecast based on moon phases, sunrise, and sunset data. Local conditions,\n            weather fronts, and barometric pressure can also affect fish activity. Many fishermen keep a journal detailing\n            weather information to help determine the patterns and fishing strategies that work best for different seasons\n            and weather scenarios, and we recommend you do the same. During the summer months, when the weather is hot,\n            plan on fishing in the early morning or in the evening. During the winter, great fishing can be had during\n            the middle of the day.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            According to John Alden Knight's famous Solunar Theory, fish become more active and feeding increases during two major periods\n            each day and increases to a lesser extent during two minor periods each day. Major Feeding Times occur when\n            the moon is directly overhead a point on the Earth's surface or directly below and Minor Feeding Times occur\n            during moon rise and moon set, when the moon is on the horizon.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-12"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "alt": "Graphic depiction of major and minor feeding times",
      "title": "Lunar Major Feeding Times",
      "src": "/static/img/Lunar-Major-Feeding-Times.jpg"
    }
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ad row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h3', [_vm._v("LOCATION SPECIFIC CHARTS")]), _vm._v(" "), _c('p', [_vm._v("\n        Use our free online tool to make the most out of your time on the water. The charts will forecast fish activity for any US\n        state based on your zipcode and show you the best fishing days in your area.\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Good luck and remember that a bad day of fishing is better than a good day of work!\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Lunar Fishing Calendar",
      "href": "/lunar-fishing-calendar"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "alt": "Free lunar fishing calendar"
    }
  }, [_vm._v("Lunar Fishing Calendar")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "row hunt"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('h3', [_vm._v("FISHING FOR LARGEMOUTH BASS")]), _vm._v(" "), _c('p', [_vm._v("\n        For many people, the largemouth bass holds a special place in their hearts. It was the first fish they caught and helped\n        spark a life long passion for fishing and enjoying the outdoors with family and friends. The largemouth bass, aptly\n        named for its huge mouth, is extremely prolific and prospers in every continental U.S. state. It can be found in\n        rivers, lakes and nearly every golf course, neighborhood or farm pond in the nation. With its very large mouth,\n        the largemouth has evolved to be an aggressive predator, feeding on everything from frogs, bugs, and smaller fish\n        to mice and even baby ducks.\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "title": "Fishing for largemouth bass",
      "href": "/largemouth-bass-fishing"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Read More")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col top-buffer"
  }, [_c('h4', [_vm._v("Also interested in Hunting? ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('a', {
    attrs: {
      "href": "https://www.deerfeedingchart.com"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Best Hunting Days")])])])
}]}

/***/ })
],[34]);


// WEBPACK FOOTER //
// static/js/app.16e22ff68767a46a7198.js